// extracted by mini-css-extract-plugin
module.exports = {"label":"datafilterdaterangebox_label__qVNiS","btnCalendar":"datafilterdaterangebox_btnCalendar__2FOOH","calendarBox":"datafilterdaterangebox_calendarBox__YT-WX"};